import { z } from "zod";
import { BladeHeaderSchema } from "../../BladeHeader";
import { BladeCommonSchema } from "../../../types";
import { BackdropSchema } from "../../Backdrop";
import { MediaPromoItemSchema } from "../../MediaPromoItem";
export const MediaPromosListBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    items: z.array(MediaPromoItemSchema).nonempty(),
});
export const transformToGroupedMediaPromos = (items) => {
    return items.map((item) => ({
        label: "",
        thumbnail: item.media,
        content: { ...item },
    }));
};
//# sourceMappingURL=index.js.map